export const shadows = {
  none:    'none',
  xs:      '0 1px 2px rgba(0, 0, 0, 0.05)',
  sm:      '0 2px 6px rgba(76, 78, 111, 0.06)',
  md:      '0 4px 16px rgba(76, 78, 111, 0.08)',
  lg:      '0 8px 24px rgba(76, 78, 111, 0.12)',
  xl:      '0 16px 32px rgba(76, 78, 111, 0.16)',
  primary: '0 4px 8px rgba(115, 103, 240, 0.3)',
  card:    '0px 8px 24px rgba(76, 78, 111, 0.08)',
} as const;
